import React from 'react';
import { Paper, Typography } from '@mui/material';

const BuySellMetricCard = ({ label, value, helper }) => {
  return (
    <Paper variant="outlined" sx={{ p: 2, flex: 1, minWidth: { xs: '100%', md: 0 } }}>
      <Typography variant="overline" sx={{ color: 'text.secondary' }}>
        {label}
      </Typography>
      <Typography variant="h4" sx={{ fontWeight: 700 }}>
        {value}
      </Typography>
      {helper && (
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {helper}
        </Typography>
      )}
    </Paper>
  );
};

export default BuySellMetricCard;
